import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Paper,
  Box,
} from "@mui/material";
import {
  validateNumber,
  validatePercentage,
  validatePercentageInput,
} from "../../../../utils/validateFields";

const SingleColumn = ({
  setFormData,
  formData,
  setErrors,
  errors,
  disabled,
}) => {
  const rows = [
    {
      category: "Environmental and social parameters relevant to the product",
      fieldName: "environmentalAndSocialParameters",
    },
    {
      category: "Safe and responsible usage",
      fieldName: "safeAndResponsibleUsage",
    },
    {
      category: "Recycling and/or safe disposal",
      fieldName: "recyclingAndSafeDisposal",
    },
  ];

  console.log(errors);
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (value !== "" && !validatePercentageInput(value)) return;

    setFormData((prev) => ({
      ...prev,
      turnoverPercentageWithInformation: {
        ...prev.turnoverPercentageWithInformation,
        [name]: value, // Update the specific key
      },
    }));

    setErrors((prev) => ({
      ...prev,
      turnoverPercentageWithInformation: {
        ...prev.turnoverPercentageWithInformation,
        [name]: "", // Update the specific key
      },
    }));
  };

  const getSegmentErrorMessages = (defaultSegments, errors) => {
    const rowErrorMessages = [];

    // Loop through each row to create error messages for missing fields
    defaultSegments.forEach((segment, rowIndex) => {
      const rowErrors = errors?.[segment?.fieldName];

      if (rowErrors) {
        const missingFields = Object.entries(rowErrors)
          .filter(
            ([_, errorMessage]) => errorMessage && errorMessage.trim() !== ""
          ) // Filter non-empty errors
          .join(", ");

        if (missingFields.length > 0) {
          // Only push if there are valid missing fields
          rowErrorMessages.push(
            `Row ${
              Number(rowIndex) + 1
            }: Missing fields - Total Turnover Percentage`
          );
        }
      }
    });
    return rowErrorMessages;
  };

  const segmentErrorMessages = getSegmentErrorMessages(rows, errors);

  return (
    <div>
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
          borderRadius: "10px",
          // ml:2,
          // width:"98%"
        }}
      >
        {" "}
        <Table>
          <TableHead>
            <TableRow style={{ backgroundColor: "#004d7a" }}>
              <TableCell
                style={{
                  color: "white",
                  fontWeight: "bold",
                  border: "1px solid #ddd",
                  width: "10rem",
                }}
              >
                Category
              </TableCell>
              <TableCell
                style={{
                  color: "white",
                  fontWeight: "bold",
                  border: "1px solid #ddd",
                  width: "10rem",
                }}
              >
                As a percentage to total turnover
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.category}</TableCell>
                <TableCell
                  sx={{
                    border: "1px solid #DBDBDB",
                    py: "0.5rem",
                  }}
                >
                  {" "}
                  <TextField
                    disabled={disabled}
                    placeholder={"Enter Percentage"}
                    fullWidth
                    name={row.fieldName}
                    value={
                      formData?.turnoverPercentageWithInformation?.[
                        row.fieldName
                      ]
                    }
                    variant="standard"
                    size="small"
                    onChange={handleChange}
                    InputProps={{ disableUnderline: true }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Box sx={{ mt: 2, ml: 1 }}>
        {segmentErrorMessages?.map((errorMessage, idx) => (
          <p
            key={idx}
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errorMessage}
          </p>
        ))}
      </Box>
    </div>
  );
};

export default SingleColumn;
